import YoutubePlayer from "./components/YoutubePlayer";
import VimeoPlayer from "./components/VimeoPlayer";
import CustomPlayer from "./components/CustomPlayer";

// Componente principal de VideoPlayer
const VideoPlayer = ({ videoSource, title }) => {
  // Verificar si la URL es de YouTube
  const isYouTubeUrl = (url) => {
    return url?.includes("youtube.com") || url?.includes("youtu.be");
  };

  // Verificar si la URL es de Vimeo
  const isVimeoUrl = (url) => {
    return url?.includes("vimeo.com");
  };

  // Renderizar el reproductor de YouTube si es una URL de YouTube
  if (isYouTubeUrl(videoSource)) {
    return <YoutubePlayer videoUrl={videoSource} />;
  }
  // Renderizar el reproductor de Vimeo si es una URL de Vimeo
  else if (isVimeoUrl(videoSource)) {
    return <VimeoPlayer videoUrl={videoSource} />;
  }
  // Si no es ni de YouTube ni de Vimeo, mostrar el reproductor personalizado
  else {
    return <CustomPlayer videoSource={videoSource} title={title} />;
  }
};

export default VideoPlayer;
